module.exports = __webpack_public_path__ + "img/ps.043abef5.svg";